// extracted by css-extract-rspack-plugin
export default {"root":"ZZkntD","title":"zrWMDp","body":"de4tJK"};